import { Component, forwardRef, Input, OnInit } from '@angular/core';
import { NG_VALUE_ACCESSOR, UntypedFormControl } from '@angular/forms';
import { FormService } from '../../form.service';
import { Option } from '../../interfaces/option-interface';
import { Question } from '../../interfaces/scale.interface';
import { BaseControlValueAccessorComponent } from '../base-control-value-accessor/base-control-value-accessor.component';

interface Scale {
  question: Option;
  answers: Option[] | null;
}

@Component({
  selector: 'app-scale',
  templateUrl: './scale.component.html',
  styleUrls: ['./scale.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => ScaleComponent),
      multi: true,
    },
  ],
})
export class ScaleComponent extends BaseControlValueAccessorComponent implements OnInit {
  @Input() title = 'lorem ipsum';
  @Input() lead: string | null | undefined = 'Kérjük válasszon az alábbi kérdésekre';
  @Input() scaleRows: Scale[] = [];
  @Input() answers: Option[] | undefined = [];
  @Input() questions: Question[] | undefined = [];
  @Input() type = '';
  @Input() required = false;
  @Input() formControl = new UntypedFormControl();
  selectedValues: any = [];

  constructor(public formService: FormService) {
    super();
  }

  ngOnInit(): void {
    if (this.type === '') {
      this.questions?.forEach((q) => {
        this.scaleRows.push({ question: { text: q.text, id: q.id }, answers: this.answers ?? null });
        this.selectedValues.push(null);
      });
    } else {
      this.questions?.forEach((q) => {
        this.scaleRows.push({ question: { text: q.text, id: q.id }, answers: q.answers });
        this.selectedValues.push(null);
      });
    }
    if (this.formControl.value) {
      this.selectedValues = this.formControl.value;
      this.formControl.markAsDirty();
    }
  }

  isSelected(id: string, index: string): boolean {
    return id === this.selectedValues[index]?.answerId;
  }

  select(event: Event, id: string, index: number): void {
    event.preventDefault();
    if (this.selectedValues[index] === id || this.formControl.disabled) return;
    this.selectedValues[index] = { questionId: this.questions?.[index].id, answerId: id };
    if (this.selectedValues.includes(null)) return;
    this.formControl.setValue(this.selectedValues);
  }
}
